export const siteInfo = {
  name: "猛男诞生记",
  tagline: "从零到猛男的完整蜕变指南",
  description: "猛男诞生记——记录一个普通人如何通过科学训练、饮食管理和意志锻炼，一步步蜕变为真正猛男的全过程。无论你是健身小白还是瓶颈期老手，这里有最真实的猛男诞生记全程干货。",
  keywords: "猛男诞生记,猛男训练计划,从零增肌,硬核健身教程,猛男体型塑造,增肌饮食方案,意志力突破训练",
  url: "https://mengnan-danshengji.com",
  logo: "猛男诞生记",
  foundingYear: 2020,
  email: "contact@mengnan-danshengji.com",
  phone: "400-888-9999",
  wechat: "mengnan_official",
  address: "北京市朝阳区建国路88号SOHO现代城A座1508",
  socialLinks: {
    weibo: "https://weibo.com/mengnan",
    bilibili: "https://bilibili.com/mengnan",
    douyin: "https://douyin.com/mengnan",
    xiaohongshu: "https://xiaohongshu.com/mengnan",
  },
  stats: {
    readers: 1280000,
    articles: 586,
    coaches: 32,
    years: 6,
  },
};

export const testimonials = [
  {
    id: 1,
    name: "李明",
    age: 28,
    duration: "6个月",
    before: "体重55kg，体型瘦弱，经常被嘲笑'竹竿'",
    after: "体重72kg，体脂率15%，穿衣显瘦脱衣有肉",
    avatar: "https://readdy.ai/api/search-image?query=Fit%20Chinese%20man%20portrait%2C%20clean%20muscular%20build%2C%20warm%20confident%20smile%2C%20studio%20lighting%2C%20simple%20neutral%20background%2C%20professional%20headshot%20style%2C%20athletic%20appearance&width=200&height=200&seq=testimonial-avatar-1&orientation=squarish",
  },
  {
    id: 2,
    name: "张伟",
    age: 35,
    duration: "12个月",
    before: "体重95kg，体脂率28%，典型的办公室'油腻大叔'",
    after: "体重82kg，体脂率12%，六块腹肌清晰可见",
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20man%20fitness%20transformation%20portrait%2C%20athletic%20build%2C%20confident%20expression%2C%20clean%20background%2C%20professional%20headshot%2C%20warm%20studio%20lighting&width=200&height=200&seq=testimonial-avatar-2&orientation=squarish",
  },
  {
    id: 3,
    name: "王强",
    age: 22,
    duration: "3个月",
    before: "大学生，体能极差，引体向上一个都做不了",
    after: "体能飞跃，引体向上一组15个，深蹲100kg",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20athletic%20portrait%2C%20fit%20body%2C%20determined%20expression%2C%20simple%20studio%20background%2C%20professional%20lighting%2C%20clean%20style&width=200&height=200&seq=testimonial-avatar-3&orientation=squarish",
  },
];

export const brandValues = [
  {
    title: "科学为本",
    description: "所有训练方法和饮食建议均基于运动科学和营养学最新研究成果，拒绝伪科学和速成谣言。我们的教练团队持有国际认证资质，确保每一条建议都经得起推敲。",
    icon: "ri-flask-line",
  },
  {
    title: "真实记录",
    description: "猛男诞生记坚持真实记录每一个蜕变故事，不夸大、不造假。每篇文章都凝聚着真实的汗水与坚持，每一个数据都有据可查。",
    icon: "ri-file-text-line",
  },
  {
    title: "陪伴成长",
    description: "健身不是一个人的战斗。我们打造了活跃的社群氛围，让每一位猛男之路上的伙伴都能找到归属感和前进动力。",
    icon: "ri-team-line",
  },
  {
    title: "持续进化",
    description: "健身知识在不断更新，我们也在持续学习和进化。每年邀请国内外顶级教练进行内容审核和更新，确保你不走弯路。",
    icon: "ri-loop-left-line",
  },
];

export const faqData = [
  {
    question: "猛男诞生记适合完全没有健身基础的小白吗？",
    answer: "当然适合！我们的内容体系从零基础开始设计，循序渐进。新手专区包含动作图解、训练计划模板、饮食入门指南等，确保你可以安全、高效地开始你的猛男之旅。",
  },
  {
    question: "我需要购买昂贵的健身器材吗？",
    answer: "不需要。我们提供了大量徒手训练和简易器械训练方案。一副可调节哑铃和一根弹力带就可以完成90%的训练内容。随着训练深入，再根据需求逐步添置器材即可。",
  },
  {
    question: "训练计划需要多久才能看到效果？",
    answer: "每个人起点不同，但一般来说：坚持训练2-4周可以感受到体能提升；6-8周可以看到体型初步变化；12周以上会有明显的体型改变。关键在于坚持和科学方法，而非追求速成。",
  },
  {
    question: "饮食方案需要严格计算卡路里吗？",
    answer: "新手阶段不要求严格计算卡路里，我们提供了'手掌测量法'等简便方法。随着训练深入，如果你希望更精细地控制体型，可以逐步学习营养计算。我们提供了从入门到进阶的完整饮食方案。",
  },
  {
    question: "女生也可以使用猛男诞生记的内容吗？",
    answer: "训练和营养的基本原则是通用的，但男女在激素水平、体型目标上有差异。我们的核心方法论适用于所有人，针对女性需求也有专门的调整建议。欢迎所有追求健康体魄的朋友！",
  },
  {
    question: "如何加入猛男诞生记的社群？",
    answer: "你可以关注我们的微信公众号、加入微信群、或在小红书/B站/抖音搜索'猛男诞生记'关注我们。社群内每天有教练答疑、训练打卡、饮食分享等活动，还有不定期的线下聚会。",
  },
];